var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"app-view"},[_c('AppSidebar'),_c('div',{staticClass:"main-body"},[_c('div',{staticClass:"container-fluid"},[_c('router-view',{key:_vm.$route.fullPath + '|' + _vm.$i18n.locale})],1)])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }